import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-ml-2 p-p-2 p-component" }
const _hoisted_2 = { class: "header p-component" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-2" }
const _hoisted_5 = { class: "p-field p-col-2" }
const _hoisted_6 = { class: "p-field p-col-2" }
const _hoisted_7 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_9 = { class: "p-col-12 p-field p-input-filled" }
const _hoisted_10 = { for: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_LabelNode = _resolveComponent("LabelNode")!
  const _component_CustomNode = _resolveComponent("CustomNode")!
  const _component_DataNode = _resolveComponent("DataNode")!
  const _component_MiniMap = _resolveComponent("MiniMap")!
  const _component_Controls = _resolveComponent("Controls")!
  const _component_Background = _resolveComponent("Background")!
  const _component_VueFlow = _resolveComponent("VueFlow")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.XMLMapper')), 1),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "p-field p-col-2" }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "p-offset-4" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.General.Upload'),
            type: "button",
            icon: "mdi mdi-file-import-outline",
            class: "p-button",
            disabled: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = () => _ctx.showUploadDialog = true)
          }, null, 8, ["label", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.General.Save'),
            type: "button",
            icon: "mdi mdi-content-save-outline",
            class: "p-button",
            disabled: !_ctx.hasNodeTemplateChanged || _ctx.blockMapper,
            onClick: _cache[1] || (_cache[1] = () => _ctx.showSaveDialog = true)
          }, null, 8, ["label", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.General.Delete'),
            type: "button",
            icon: "mdi mdi-delete-outline",
            class: "p-button",
            severity: "danger",
            disabled: !_ctx.mapping.id,
            onClick: _cache[2] || (_cache[2] = () => _ctx.deleteDialog = true)
          }, null, 8, ["label", "disabled"])
        ])
      ]),
      (_ctx.blockMapper)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "warn",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.NotEditableXmlMapper')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "p-pt-2",
        style: _normalizeStyle(_ctx.blockMapper ? 'height: calc(100vh - 24rem)' : 'height: calc(100vh - 18rem)')
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", {
                class: "mdi mdi-spin mdi-loading",
                style: {"fontSize":"8rem"}
              }, null, -1)
            ]))]))
          : (_openBlock(), _createBlock(_component_VueFlow, {
              key: 1,
              nodes: _ctx.nodes,
              edges: _ctx.edges,
              class: "custom-node-flow",
              "fit-view-on-init": "",
              "nodes-draggable": false,
              "apply-default": false,
              onEdgesChange: _ctx.onEdgesChange,
              "default-viewport": { zoom: 1 },
              "min-zoom": 0.2,
              "max-zoom": 4
            }, {
              "node-label": _withCtx((nodeProps) => [
                _createVNode(_component_LabelNode, {
                  label: nodeProps.data.label
                }, null, 8, ["label"])
              ]),
              "node-custom": _withCtx((nodeProps) => [
                _createVNode(_component_CustomNode, _mergeProps(nodeProps, {
                  text: nodeProps.data.text
                }), null, 16, ["text"])
              ]),
              "node-data": _withCtx((nodeProps) => [
                _createVNode(_component_DataNode, _mergeProps(nodeProps, {
                  label: nodeProps.data.label
                }), null, 16, ["label"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_MiniMap),
                _createVNode(_component_Controls, {
                  showInteractive: false,
                  onZoomIn: _ctx.zoomInButton,
                  onZoomOut: _ctx.zoomOutButton,
                  onFitView: _ctx.fitViewBtn
                }, null, 8, ["onZoomIn", "onZoomOut", "onFitView"]),
                _createVNode(_component_Background, { gap: 24 })
              ]),
              _: 1
            }, 8, ["nodes", "edges", "onEdgesChange"]))
      ], 4)
    ]),
    _createVNode(_component_Dialog, {
      header: 'XML/PDF ' + _ctx.$t('Squeeze.General.Upload'),
      visible: _ctx.showUploadDialog,
      modal: true,
      closable: true,
      dismissableMask: true,
      baseZIndex: 1000,
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: {width: '50vw'},
      onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showUploadDialog = false)),
      "onUpdate:visible": _cache[4] || (_cache[4] = (value) => {if (!value) _ctx.showUploadDialog = false})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FileUpload, {
          name: "importXMLFile",
          customUpload: true,
          showCancelButton: true,
          uploadFiles: _ctx.files,
          customProgress: _ctx.progress,
          uploadLabel: _ctx.uploadLabel,
          fileContentHeight: '15.625rem',
          invalidFileSizeMessage: '{0}: ' + _ctx.$t('Squeeze.Validation.General.InvalidFileSize') + ' ' + '{1}',
          chooseLabel: _ctx.$t('Squeeze.General.Choose'),
          cancelLabel: _ctx.$t('Squeeze.General.Clear'),
          onUploader: _ctx.fileUploader,
          onSelect: _ctx.onSelectFiles,
          onClear: _ctx.clearFiles,
          onRemoveFile: _ctx.removeFile
        }, null, 8, ["uploadFiles", "customProgress", "uploadLabel", "invalidFileSizeMessage", "chooseLabel", "cancelLabel", "onUploader", "onSelect", "onClear", "onRemoveFile"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showSaveDialog,
      onOnClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSaveDialog = false)),
      onOnConfirm: _ctx.saveMapping,
      loading: _ctx.loading,
      headerText: 'Test',
      showSaveButton: _ctx.mapping.name.length >= 3
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.MapperSafeInfo')), 1),
        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.General.Name')) + " *", 1),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.mapping.name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mapping.name) = $event)),
              minlength: "3",
              autofocus: ""
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "showSaveButton"]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteMapping
    }, null, 8, ["showDialog", "onOnConfirm"])
  ], 64))
}